import { useEffect, useMemo, useState } from "react";
import { Grid, Button } from "@mui/material";
import AddBox from "@mui/icons-material/AddBox";

// Non-Flying Assignment Form Imports
import { IPositioningFlight } from "@vmosolutions/oc-interfaces";
import { PositioningFlightForm, initialValues } from "../Forms/PositioningFlightForm";

interface IPositioningFlightsTabProps {
  id: string;
  className: string;
  positioningFlight: IPositioningFlight; // incoming event for edit
  updatePositioningFlight: (positioningFlight: IPositioningFlight, eventType: string) => void; // outgoing edited event
}

/**
 * Pairing Events tab contains forms used for creation and editing of non-flying assignments and positioning flights
 * @param props -
 */
export const PositioningFlightsTab = (props: IPositioningFlightsTabProps): JSX.Element => {
  const { id, className, positioningFlight, updatePositioningFlight } = props;
  const [initialFormValues, setInitialFormValues] = useState<IPositioningFlight>(initialValues);
  const isNew = !initialFormValues?._id && !initialFormValues?._tempId;

  const mosaicPane = useMemo(() => {
    return id ? document.getElementById(`${id}-panel`) : null;
  }, [id]);

  // If a positioningFlight is passed through props, set it as initial form values.
  useEffect(() => {
    setInitialFormValues(positioningFlight);
  }, [positioningFlight]);

  return (
    <Grid container direction="column" className={className}>
      <Grid item className="event_actions">
        <Grid container direction="row">
          <Button
            className="action_btn"
            disabled={isNew}
            onClick={() => {
              setInitialFormValues(initialValues);
            }}
          >
            <AddBox /> Add New
          </Button>
        </Grid>
      </Grid>

      <Grid item>
        <PositioningFlightForm
          isNew={isNew}
          mosaicPane={mosaicPane}
          positioningFlight={initialFormValues}
          updatePositioningFlight={(positioningFlight: IPositioningFlight) => {
            updatePositioningFlight(positioningFlight, "posFlight");
          }}
        />
      </Grid>
    </Grid>
  );
};
